/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sources_2_LabelInputs */

const en_gc_search_guides_what_is_gridcraft_sources_2_label = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sources_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official v0.7.0 release and downloads`)
};

const zh_gc_search_guides_what_is_gridcraft_sources_2_label = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sources_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官方 v0.7.0 发布与下载`)
};

/**
* | output |
* | --- |
* | "Official v0.7.0 release and downloads" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sources_2_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sources_2_label = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sources_2_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sources_2_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sources_2_label(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sources_2_label(inputs)
});
export { gc_search_guides_what_is_gridcraft_sources_2_label as "gc.search_guides.what_is_gridcraft.sources.2.label" }